import { makeStyles } from "@material-ui/core";
import { DESKTOP_BREAKPOINT } from "./consts";

export const useShimmerStyles = makeStyles((theme) => ({
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "-900px 0" },
    "100%": { backgroundPosition: "900px 0" },
  },

  block: {
    background: "linear-gradient(90deg, #ececec 25%, #d8d8d8 50%, #ececec 75%)",
    backgroundSize: "900px 100%",
    animation: "$shimmer 1.5s infinite linear",
    borderRadius: "6px",
  },

  mobileWrapper: {
    width: "100%",
  },

  headerWrapper: {
    background: "#FFF5D6",
    padding: "32px 40px",
    display: "flex",
    alignItems: "center",
    gap: "24px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      padding: "20px 16px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "16px",
    },
  },

  profileCircle: {
    width: "100px",
    height: "100px",
    borderRadius: "16px",
    flexShrink: 0,
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      width: "72px",
      height: "72px",
    },
  },

  headerRight: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  nameRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },

  statsWrapper: {
    background: "#FAFAFA",
    padding: "24px 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      padding: "20px 16px",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
    },
  },

  statItem: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: 1,
  },

  contentWrapper: {
    maxWidth: "90%",
    margin: "0 auto",
    padding: "32px 40px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      padding: "24px 16px",
    },
  },

  chipsRow: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },

  infoRow: {
    display: "flex",
    gap: "16px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      flexDirection: "column",
      gap: "8px",
    },
  },

  divider: {
    width: "100%",
    height: "1px",
    background: "#E0E0E0",
    margin: "8px 0",
  },
}));

export const mentorProfileStyles = makeStyles((theme) => ({
  wrapper: {
    maxWidth: "1440px",
    margin: "auto",
    padding: "24px 16px",
    [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
      padding: "0px 40px 14px",
    },

    "& .editableContainer input, .editableContainer textarea": {
      border: "1px solid #C4C4C4",
      borderRadius: "4px",
      padding: "8px",
      color: "#666666",
      fontWeight: 500,
      width: "100%",
    },

    "& .editableContainer:not(.aboutText) .text": {
      color: "#3D3D3D",
      fontWeight: 500,
      fontFamily: "Roboto",
      fontSize: "16px",
    },

    "& *": {
      fontFamily: "'Inter', sans-serif",
    },
    "& p": {
      marginBottom: 0,
    },
  },

  ratingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& > :first-child": {
      fontFamily: "'Inter', sans-serif",
      color: "#3D3D3D",
      fontWeight: 600,
      textAlign: "center",
      marginBottom: "20px",
      fontSize: "16px",
    },
  },
}));

export const useProfileInfoStyles = makeStyles((theme) => ({
  profilePicContainer: {
    display: "flex",
  },
  profilePicContainerSpaceBetween: {
    justifyContent: "space-between",
  },
  profilePicContainerCenter: {
    justifyContent: "center",
  },
  profilePicContainerStart: {
    justifyContent: "flex-start",
  },
  profilePictureWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",

    [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
      position: "absolute",
      transform: "translate(0px, -50%)",
    },

    "& > :first-child": {
      position: "relative",
      width: "128px",
      height: "128px",
      border: "4px solid #FFF",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#F5F5F5",

      [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
        width: "174px",
        height: "174px",
      },
    },
  },

  profileImg: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
  },

  badgeWrapper: {
    width: "128px",
    height: "128px",
    [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
      width: "174px",
      height: "174px",
    },
    "& > img": {
      width: "100%",
      height: "100%",
      borderRadius: "50%",
    },
  },

  uploadBtn: {
    display: "flex",
    gap: "8px",
    fontSize: "14px",
    marginTop: "8px",
    color: "#666666",
  },

  uploadImageWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      gap: "12px",
    },
  },

  editableInfo: {
    display: "flex",
    width: "100%",
    maxWidth: "373px",
    marginTop: "24px",
    gap: "16px",

    "& > div": {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },

    "& > div > div .editableContainer > .text": {
      color: "#3D3D3D !important",
      fontSize: "24px !important",
      fontWeight: "700 !important",
      width: "100% !important",
    },
    "& .editableContainer .text": {
      color: "#666666 !important",
      fontSize: "16px !important",
      fontFamily: "'Inter', sans-serif !important",
    },

    [theme.breakpoints.up(DESKTOP_BREAKPOINT)]: {
      marginTop: "120px",
    },
  },

  ratingContainer: {
    alignSelf: "end",
    "& > :first-child": {
      fontFamily: "'Inter', sans-serif",
      color: "#3D3D3D",
      fontWeight: 600,
      textAlign: "center",
      marginBottom: "20px",
      fontSize: "16px",
    },
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "none",
    },
  },
}));

export const profileBannerStyles = makeStyles((theme) => ({
  bannerWrapper: {
    width: "100%",
    height: "240px",
    [theme.breakpoints.between(800, 1050)]: {
      height: "290px",
    },
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      display: "none",
    },
  },

  container: {
    margin: "auto",
    maxWidth: "800px",
    padding: "0px 12px 20px",
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    [theme.breakpoints.down(1300)]: {
      margin: "0 0 0 auto",
    },
    [theme.breakpoints.down(1250)]: {
      paddingBottom: "40px",
    },
  },

  badgeInfoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  bannerheading: {
    background: "linear-gradient(90.56deg, #3702A2 0%, #6A02A2 90.15%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    "background-clip": "text",
    fontSize: "40px",
    fontWeight: 700,
    marginBottom: "24px",
  },

  badgeInfo: {
    color: "#602CC9",
    fontWeight: 500,
  },

  CertifiedMentorHeading: {
    background: " linear-gradient(90.76deg, #8D3901 0%, #A24202 66.24%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    "background-clip": "text",
  },

  CertifiedMentorInfo: {
    color: "#C96B2C",
  },

  imageContainer: {
    position: "relative",
  },

  imgBg: {
    width: "216px",
  },

  img: {
    width: "160px",
    height: "160px",
    position: "absolute",
    top: "10px",
    left: "50%",
    transform: "translate(-50%)",
  },
}));

export const commonStyles = makeStyles((theme) => ({
  buttonReset: {
    all: "unset",
    appearance: "none",
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    font: "inherit",
    color: "inherit",
    textAlign: "inherit",
    cursor: "pointer",
    outline: "none !important",
  },

  viewProfileBtn: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#404040",
    border: "2px solid #404040",
    borderRadius: "16px",
    lineHeight: "24px",
    padding: "6px 16px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "14px",
      padding: "4px 12px",
    },
  },

  fileUploader: {
    position: "fixed",
    top: "-100px",
    display: "none",
  },

  divider: {
    width: "100%",
    height: "1px",
    backgroundColor: "#E0E0E0",
    margin: "40px 0",

    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      margin: "24px 0",
    },
  },

  spinner: {
    width: 20,
    height: 20,
    border: "2px solid #ccc",
    borderTop: "2px solid #000",
    borderRadius: "50%",
    animation: "$spin 1s linear infinite",
    margin: "0 4px",
    display: "inline-block",
  },
  selectedLanguagesContainer: {
    display: "flex",
    flexWrap: "nowrap",
    gap: "8px",
    alignItems: "center",
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    "&::-webkit-scrollbar": {
      height: "4px",
    },
  },
  languageChip: {
    backgroundColor: "#F5F5F5",
    borderRadius: "8px",
    height: "28px",
    "& .MuiChip-label": {
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: 1.4,
      color: "#3D3D3D",
      padding: "0 8px",
    },
    "& .MuiChip-deleteIcon": {
      color: "#666666",
      margin: "0 6px 0 -2px",
      "&:hover": {
        color: "#3D3D3D",
      },
    },
  },
  selectMenuPaper: {
    maxHeight: "196px",
    overflowY: "auto",
    marginTop: "4px",
    borderRadius: "8px",
    border: "1px solid #E0E0E0",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.08)",
  },
  selectMenuList: {
    padding: "4px 0",
  },
  selectMenuItem: {
    minHeight: "48px",
    "& .MuiListItemText-primary": {
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: 1.4,
      color: "#3D3D3D",
    },
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export const useEarningStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
  },

  headerSection: {
    display: "flex",
    justifyContent: "space-between",
    margin: "32px 0",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "24px",
    },
  },
  titleSection: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      alignItems: "center",
    },
  },
  title: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "20px",
    fontWeight: 700,
    color: "#3D3D3D",
    marginBottom: "8px",
    display: "flex",
    gap: "12px",
    alignItems: "center",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      justifyContent: "center",
    },
  },
  earningsText: {
    fontSize: "14px",
    color: "#6b7280",
  },
  totalAmount: {
    fontSize: "48px",
    fontWeight: 700,
    color: "#059669",
    margin: "12px 0",
    lineHeight: "normal",
  },
  disclaimer: {
    fontSize: "12px",
    color: "#6b7280",
    fontStyle: "italic",
  },
  dateSection: {
    marginTop: "24px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      justifyContent: "center",
    },
  },
  dateLabel: {
    fontSize: "14px",
    color: "#374151",
    fontWeight: 500,
  },
  dateInput: {
    background: "#F5F5F5",
    borderRadius: "8px",
    padding: "8px 12px",
    fontSize: "16px",
    border: "none",
    minWidth: "128px",
    textAlign: "center",
    fontWeight: 500,
    color: "#666666",
    fontFamily: "Roboto",
    cursor: "pointer",
  },

  mainContent: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "48px",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
      gap: "32px",
    },
  },
  earningsSummary: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },

  sectionTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#666666",
    marginBottom: "11px",
  },
  summaryItem: {
    display: "flex",
    justifyContent: "space-between",
    gap: "30px",
    alignItems: "center",
    padding: "7px 0",
  },
  summaryLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    color: "#374151",
  },
  summaryValue: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#1f2937",
  },
  icon: {
    width: "16px",
    height: "16px",
    borderRadius: "2px",
  },
  raiseDisputeButton: {
    backgroundColor: "#F5F5F5",
    color: "#666666",
    padding: "8px 16px",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    border: "none",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    textTransform: "none",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#E0E0E0",
    },
    "&:active": {
      backgroundColor: "#D0D0D0",
    },
    "&:disabled": {
      backgroundColor: "#E0E0E0",
      color: "#A0A0A0",
      cursor: "not-allowed",
    },
  },
  EditDisputeContainer: {
    width: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    fontSize: "16px",
    fontWeight: 500,
    color: "#DD8E18",
    textTransform: "none",
    backgroundColor: "#FDF6ED",
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    transition: "background-color 0.2s ease",
    // position: "relative",
  },
  editDisputeButton: {
    border: "none",
    marginRight: "8px",
    backgroundColor: "transparent",
    color: "#666666",
    cursor: "pointer",
    "&:hover": {
      color: "#333333",
    },
  },
  // Right column - Empty on desktop, content flows below on mobile
  rightColumn: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  // Sections below main content
  sectionsContainer: {
    marginTop: "48px",
  },
  section: {
    marginBottom: "48px",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    borderBottom: "1px solid #E0E0E0",
    paddingBottom: "8px",
    marginBottom: "20px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      justifyContent: "center",
    },
  },
  sectionHeaderTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#3D3D3D",
    marginBottom: 0,
  },
  viewDetailsLink: {
    fontSize: "14px",
    color: "#F66C28",
    textDecoration: "none",
    fontWeight: 600,
    cursor: "pointer",
  },
  viewDetailsPenalizedClasses: {
    fontSize: "12px",
    color: "#666666",
    textDecoration: "none",
    fontWeight: 400,
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 200px))",
    gap: "32px",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: "24px",
    },
  },
  statItem: {
    display: "flex",
    flexDirection: "column",
  },
  statLabel: {
    fontSize: "14px",
    color: "#666666",
    marginBottom: "8px",
    fontFamily: "Roboto",
  },
  statValue: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#3D3D3D",
    fontFamily: "Roboto",
  },
  penalizedSection: {
    marginBottom: "48px",
  },
  penalizedHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "8px",
  },
  penalizedTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#1f2937",
  },
  infoIcon: {
    width: "16px",
    height: "16px",
    backgroundColor: "#d1d5db",
    borderRadius: "50%",
  },
  penalizedNote: {
    fontSize: "12px",
    color: "#6b7280",
    marginBottom: "0",
    display: "flex",
    gap: "6px",
    alignItems: "center",
  },
  penalizedGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "24px",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: "16px",
    },
  },
}));

export const useRatingStyles = makeStyles((theme) => ({
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "-700px 0" },
    "100%": { backgroundPosition: "700px 0" },
  },
  shimmerBlock: {
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "700px 100%",
    animation: "$shimmer 1.4s infinite linear",
    borderRadius: "6px",
  },
  shimmerWrapper: {
    display: "flex",
    gap: "40px",
    [theme.breakpoints.down(1100)]: {
      flexDirection: "column",
      gap: "24px",
    },
  },
  shimmerLeft: {
    display: "flex",
    gap: "40px",
    flex: 1,
    maxWidth: "550px",
    [theme.breakpoints.down(1100)]: { maxWidth: "100%" },
    [theme.breakpoints.down(500)]: { flexDirection: "column" },
  },
  shimmerOverview: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  shimmerRight: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  shimmerTabs: {
    display: "flex",
    gap: "12px",
    marginBottom: "16px",
  },
  container: {
    display: "flex",
    gap: "40px",
    justifyContent: "space-between",
    [theme.breakpoints.down(1100)]: {
      gap: "24px",
      flexDirection: "column",
    },
  },
  title: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "42px",
    lineHeight: "48px",
    fontWeight: 700,
    color: "#404040",
    letterSpacing: "-4%",
    marginBottom: "32px",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      fontSize: "24px",
      textAlign: "left",
      marginBottom: "16px",
    },
  },
  titleHighlight: {
    color: "#C79000",
    position: "relative",
  },
  titleHighlightImg: {
    position: "absolute",
    bottom: "-14px",
    left: 35,
    width: "65px",
    height: "auto",
    [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
      left: "20px",
      bottom: "-8px",
      width: "40px",
    },
  },
    ratingsSection: {
      display: "flex",
      gap: "40px",
      marginBottom: "30px",
      maxWidth: "550px",
      [theme.breakpoints.down(1100)]: {
        maxWidth: "100%",
      },
      [theme.breakpoints.down(500)]: {
        flexDirection: "column",
      },
      flex: "1",
    },
    ratingOverview: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    ratingNumber: {
      fontSize: "48px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "10px",
      lineHeight: "normal",
    },
    stars: {
      display: "flex",
      gap: "2px",
      marginBottom: "10px",
    },
    star: {
      width: "18px",
      height: "18px",
      objectFit: "contain",
    },
    starEmpty: {
      width: "18px",
      height: "18px",
      objectFit: "contain",
    },
    reviewCount: {
      fontSize: "16px",
      color: "#404040",
      fontWeight: 600,
      [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
        fontSize: "14px",
      },
      
    },
    ratingBars: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      minWidth: "320px",
    },
    ratingBar: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    ratingLabel: {
      fontSize: "14px",
      color: "#666",
      minWidth: "15px",
    },
    progressBar: {
      flex: 1,
      height: "8px",
      backgroundColor: "#e0e0e0",
      borderRadius: "4px",
      overflow: "hidden",
    },
    progress: {
      height: "100%",
      borderRadius: "4px",
    },
    ratingCount: {
      fontSize: "14px",
      color: "#666",
      minWidth: "30px",
      textAlign: "right",
    },

    tabs: {
      width: "100%",
      maxWidth: "650px",
      [theme.breakpoints.down(1100)]: {
        maxWidth: "100%",
      },
    },

    tabsContainer: {
      borderBottom: "1px solid #e0e0e0",
      marginBottom: "10px",
    },
    tabsList: {
      display: "flex",
      alignItems: "center",
      listStyle: "none",
      padding: 0,
      margin: 0,
      gap: "30px",
      overflowX: "auto",
      scrollbarWidth: "none",
    },
    tab: {
      padding: "0 0 12px 0",
      minWidth: "fit-content",
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "600",
      color: "#666",
      borderBottom: "2px solid transparent",
      transition: "all 0.3s ease",
      display: "flex",
      gap: "2px",
    },
    tabActive: {
      color: "#F66C28",
      borderBottom: "3px solid #F66C28",
      fontWeight: "700",
    },
    tabContent: {
      maxHeight: "500px",
      overflowY: "auto",
      paddingRight: "16px",
      minHeight: "200px",
    },
    reviewCard: {
      padding: "20px 0",
      borderBottom: "1px solid #f0f0f0",
    },
    reviewCardLast: {
      borderBottom: "none",
    },
    reviewHeader: {
      display: "flex",
      alignItems: "flex-start",
      gap: "4px",
      flexDirection: "column",
      marginBottom: "10px",
    },
    parentName: {
      fontSize: "16px",
      fontWeight: "700",
      color: "#333",
      lineHeight: "24px",
      textTransform: "capitalize",
    },
    reviewDate: {
      fontSize: "14px",
      color: "#666",
      fontWeight: 600,
    },
    reviewStars: {
      display: "flex",
      gap: "2px",
      marginBottom: "10px",
    },
    reviewText: {
      fontSize: "16px",
      color: "#404040",
      lineHeight: "1.5",
      textTransform: "capitalize",
      fontWeight: 600,
    },
    chipBase: {
      display: "inline-flex",
      alignItems: "center",
      padding: "6px 12px",
      borderRadius: 12,
      fontWeight: "bold",
      fontSize: 14,
    },
    Good: {
      backgroundColor: "#E6F4EA",
      color: "#1B5E20",
    },
    Average: {
      backgroundColor: "#FFF8E1",
      color: "#F58900",
    },
    Bad: {
      backgroundColor: "#FDECEA",
      color: "#D32222",
    },
    icon: {
      width: 16,
      height: 16,
      marginLeft: 6,
    },

    count: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#E0E0E0",
      color: "#666666",
      width: "25px",
      height: "25px",
      borderRadius: "50%",
      marginLeft: "8px",
      fontSize: "13px",
      fontWeight: 500,
    },
  }));

export const useMockVideoStyles = makeStyles(() => ({
  section: {
    marginTop: "20px",
  },

  title: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "10px",
  },

  inputContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "flex-start",
  },

  inputField: {
    width: "280px",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "14px",
    outline: "none",
  },

  submitBtn: {
    backgroundColor: "#F66C28",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: 500,
    transition: "0.2s ease",

    "&:hover": {
      backgroundColor: "#e55a1f",
    },
  },

  videoPreview: {
    marginTop: "15px",
  },

  iframe: {
    borderRadius: "8px",
  },

  link: {
    color: "#F66C28",
    textDecoration: "none",
    fontWeight: 500,
  },

  deleteText: {
    cursor: "pointer",
    marginTop: "8px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
